import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ICustomer } from '../../core/interfaces/ICustomer';
import { MathAbsPipe } from '../../../../shared/pipes/math-abs.pipe';
import { NumberToCurrencyPipe } from '../../../../shared/pipes/number-to-currency.pipe';
import { PagedTableComponent } from '../../../../shared/components/paged-table/paged-table.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { BasePagedTableComponent } from '../../../../core/layout/components/abstracts/base-paged-table.component';
import { Observable } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { IPagedResults } from '../../../../core/interfaces/IPagedResults';
import { CustomersService } from '../../core/services/CustomersService';
import { ICustomerTransactionPosition } from '../../core/interfaces/ICustomerTransactionPosition';
import { EmptyPipe } from '../../../../shared/pipes/empty.pipe';
import { LocaleDateFormatPipe } from '../../../../shared/pipes/locale-date-format.pipe';
import { TimeFormatPipe } from '../../../../shared/pipes/time-format.pipe';

@Component({
  selector: 'app-transaction-positions-table',
  standalone: true,
  imports: [
    MathAbsPipe,
    NumberToCurrencyPipe,
    PagedTableComponent,
    TranslatePipe,
    EmptyPipe,
    LocaleDateFormatPipe,
    TimeFormatPipe
  ],
  templateUrl: './transaction-positions-table.component.html',
  styleUrl: './transaction-positions-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionPositionsTableComponent extends BasePagedTableComponent<ICustomerTransactionPosition> {

  @Input({ required: true }) customer: ICustomer;

  private readonly _customersService = inject(CustomersService);

  protected override get data$(): Observable<IResponse<IPagedResults<ICustomerTransactionPosition>>> {
    return this._customersService.getCustomerTransactionPositions(this.customer.id, this.pagination);
  }
}
